import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { ShieldCheck } from "@phosphor-icons/react";
import { api, formatApiErrorDetail } from "../lib/api";

export const TrustedBrowsers = () => {
  const [count, setCount] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/auth/trusted-devices").then(({ data }) => setCount(data.count)).catch(() => setCount(0));
  }, []);

  const forgetAll = async () => {
    if (!window.confirm("Forget all remembered browsers? You'll need your 6-digit code at the next sign-in on every device.")) return;
    setBusy(true);
    try {
      const { data } = await api.post("/auth/trusted-devices/revoke-all");
      setCount(0);
      toast.success(`Forgot ${data.revoked} browser${data.revoked === 1 ? "" : "s"}`);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="trusted-browsers" className="flex items-center gap-3 text-sm">
      <span className="inline-flex items-center gap-1.5 text-ink-muted">
        <ShieldCheck size={16} />
        <span data-testid="trusted-browsers-count">
          {count === null ? "…" : `${count} remembered browser${count === 1 ? "" : "s"}`}
        </span>
      </span>
      <button type="button" onClick={forgetAll} disabled={busy || !count}
        data-testid="trusted-browsers-forget-all"
        className="text-bronze-dark hover:text-bronze underline underline-offset-4 disabled:opacity-40 disabled:no-underline">
        {busy ? "Forgetting…" : "Forget all browsers"}
      </button>
    </div>
  );
};
